import React, { useRef, useState } from 'react';

import { ChatModal } from './ChatModal';
import FloatingButton from './FloatingButton';

const Chatbot = ({ position = 'right' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [buttonPosition, setButtonPosition] = useState({ bottom: 24, left: 180 });
  const buttonRef = useRef(null);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <>
      <FloatingButton
        ref={buttonRef}
        onClick={toggleModal}
        buttonPosition={buttonPosition}
        setButtonPosition={setButtonPosition}
      />
      {isOpen && (
        <ChatModal
          toggleModal={toggleModal}
          buttonPosition={buttonPosition}
          buttonRef={buttonRef}
          position={position} // Pass position prop
        />
      )}
    </>
  );
};

export default Chatbot;
